var styles = {"samplesModal":"SamplesSelector-module_samplesModal__tPCj4","modalColor":"SamplesSelector-module_modalColor__xAD5J","wrapperItemInfo":"SamplesSelector-module_wrapperItemInfo__V1RqM","productName":"SamplesSelector-module_productName__6Pdz-"};

export { styles as default };
//# sourceMappingURL=SamplesSelector.module.scss.js.map
